var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-img',{staticClass:"home-bg-img",attrs:{"src":_vm.store.home.bgImg}}),(_vm.$vuetify.breakpoint.smAndDown)?_c('LayoutVertical',{attrs:{"data":_vm.store}}):_vm._e(),(_vm.$vuetify.breakpoint.mdAndUp)?_c('LayoutHorizontal',{attrs:{"data":_vm.store}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }